<script>
	import {PlaceDetails, selectedPlace } from './places.js'
	import SouthCamsBlurb from './info/blurb.svelte'
	import InfoWhaddon from './info/whaddon.svelte'
	import InfoHarston from './info/harston.svelte'
	import InfoRoyston from './info/royston.svelte'
	import InfoTherfield from './info/therfield.svelte'
	import InfoBarrington from './info/barrington.svelte'
	import InfoMelbourn from './info/melbourn.svelte'
	import InfoShepreth from './info/shepreth.svelte'
	import InfoWhittlesford from './info/whittlesford.svelte'

	let selected;
	let infoComponent = SouthCamsBlurb;
	const unsubscribeToSelectedPlace = selectedPlace.subscribe(value => {
		selected = value;

		switch(selected)
		{
			case "Whaddon":
				infoComponent = InfoWhaddon;
			break;
			case "Harston":
				infoComponent = InfoHarston;
			break;
			case "Royston":
				infoComponent = InfoRoyston;
			break;
			case "Therfield":
				infoComponent = InfoTherfield;
			break;
			case "Barrington":
				infoComponent = InfoBarrington;
			break;
			case "Melbourn":
				infoComponent = InfoMelbourn;
			break;
			case "Shepreth":
				infoComponent = InfoShepreth;
			break;
			case "Whittlesford":
				infoComponent = InfoWhittlesford;
			break;
			default:
				infoComponent = SouthCamsBlurb;
			break;
		}
	})
</script>

<svelte:component this={infoComponent}/>
